/**
 *
 * Mixin
 *
 */

export const HtmlMixin = {
  methods: {
    _safeHtmlFilter(html) {
      let _html = html;
      if (!_html) {
        return '';
      }
      _html = _html.replace(/<script /gi, '<sc_ ').replace(/<\/script>/gi, '</sc_>');
      _html = _html.replace(/<form /gi, '<f_ ').replace(/<\/form>/gi, '</f_>');
      _html = _html.replace(/<button /gi, '<b_ ').replace(/<\/button>/gi, '</b_>');
      _html = _html.replace(/<input /gi, '<i_ ').replace(/<\/input>/gi, '</i_>');
      _html = _html.replace(/<textarea /gi, '<t_ ').replace(/<\/textarea>/gi, '</t_>');
      _html = _html.replace(/<select /gi, '<s_ ').replace(/<\/select>/gi, '</s_>');
      return _html;
    },

    safeHtmlFilter(html) {
      let _html = this._safeHtmlFilter(html);
      let arrTags = _html.split(/(<a .*?<\/a>)/i);
      _html = '';
      for (let i = 0; i < arrTags.length; i++) {
        _html += arrTags[i].replace(/<a (.*?<img .*?)<\/a>/i, '<a_ $1</a_>');
      }
      return _html;
    },

    safeHtmlFilterInput(html) {
      let _html = this._safeHtmlFilter(html);
      _html = _html.replace(/<a /gi, '<a_ ').replace(/<\/a>/gi, '</a_>');
      return _html;
    },
  },
};

export default HtmlMixin;
